import { put, takeEvery, select } from 'redux-saga/effects'
import { Game, Api, Auth, Firebase } from '../../Core'
import * as actions from './activity.actions'

import * as indicatorsSelectors from '../Indicators/indicators.selectors'
import * as firebaseSelectors from '../../Core/Firebase/firebase.selectors'

/**
 *  Init module.
 */
function* init() {
  yield loadComponents()
}

/** loadComponents **/
export function* loadComponents() {
  const components = {}
  yield put(Game.actions.registerComponents(components))
}

export function* loadActivity() {
  const userInfo = yield select(Auth.selectors.getUserInfo)
  const { federationId } = yield select(Firebase.selectors.getUserData)

  try {
    // Load own activity
    const ownActivity = yield loadOwnActivity(userInfo.licenseId)

    yield put(actions.setActivityData(ownActivity.length ? ownActivity : []))

    // Load required activity from other players
    const otherPlayersActivity = yield loadActivityFromOthersPlayers(userInfo.licenseId)
    const federationActivity = federationId
      ? yield loadFederationActivity(userInfo.licenseData.groupId, federationId)
      : []
    const humanResourcesMessages = yield loadHumanResourcesMessages(userInfo.licenseData.groupId)
    const activityToDisplay = [
      ...otherPlayersActivity,
      ...federationActivity,
      ...humanResourcesMessages,
    ]

    if (activityToDisplay && activityToDisplay.length) {
      yield put(actions.setActivityDataOthersPlayers(activityToDisplay))
    }
  } catch (e) {
    console.log(e)
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

export function* loadOwnActivity(licenseId) {
  const indicators = yield select(indicatorsSelectors.getUserData)
  const groupData = yield select(firebaseSelectors.getGroupData)
  const isFirstTurn = indicators.turn % groupData.maxTurns === 1

  let activityToDisplay = []

  // Search for the activity logged in the previous turn. The info related with battles will not be displayed
  //(it will only be displayed in the first turn of a session)
  const activitiesPreviousTurn = yield Api.get(
    `/activities?playerId=${licenseId}&turn=${indicators.turn - 1}`,
    {}
  )
  activitiesPreviousTurn.map((activity) => activityToDisplay.push(activity))

  // If this is the first turn of the session we will search for the activity logged in the previous session
  //and will display the info related with the battles

  if (isFirstTurn) {
    const activitiesPreviousSession = yield Api.get(
      `/activities?playerId=${licenseId}&session=${groupData.session - 1}`,
      {}
    )
    activitiesPreviousSession.map(
      (activity) =>
        activity.turn !== indicators.turn - 1 &&
        (activity.type === 'BATTLE_WON' || activity.type === 'BATTLE_LOST') &&
        activityToDisplay.push(activity)
    )
  }

  return activityToDisplay
}

export function* loadFederationActivity(groupId, federationId) {
  const groupData = yield select(Firebase.selectors.getGroupData)

  const federationActivities = yield Api.get(
    `/activities?groupId=${groupId}&session=${groupData.session - 1}`,
    {}
  )

  return federationActivities.filter(
    (activity) =>
      (activity.type === 'FEDERATION_PUNISHMENT' || activity.type === 'FEDERATION_REWARD') &&
      activity.data.federationId &&
      activity.data.federationId == federationId
  )
}

export function* loadHumanResourcesMessages(groupId) {
  const groupData = yield select(Firebase.selectors.getGroupData)
  const humanResourcesMessages = yield Api.get(
    `/activities?groupId=${groupId}&session=${groupData.session}`,
    {}
  )

  return humanResourcesMessages.filter((activity) => activity.type === 'RRHH_MESSAGE')
}
export function* loadBattlesFromOthersPlayers(action) {
  let licenseId = action.data
  let otherPlayersBattleActivity = []
  const groupData = yield select(firebaseSelectors.getGroupData)

  const activityOtherPlayer = yield Api.get(
    `/activities?playerId=${licenseId}&session=${groupData.session - 1}`,
    {}
  )
  activityOtherPlayer.map(
    (activity) =>
      (activity.type === 'BATTLE_WON' || activity.type === 'BATTLE_LOST') &&
      activity.data &&
      otherPlayersBattleActivity.push(activity)
  )

  activityOtherPlayer.length
    ? yield put(actions.setActivityDataVisitingPlayers(otherPlayersBattleActivity))
    : null
}

export function* loadActivityFromOthersPlayers(licenseId) {
  let otherPlayersActivity = []

  // Find the leader
  const ranking = yield select(firebaseSelectors.getPlayersRanking)
  otherPlayersActivity.push({
    type: 'LEADER',
    data: { licenseId: ranking[0].licenseId, name: ranking[0].colonyName },
  })

  // Find the current position of the player
  const position = ranking.findIndex((item) => item.licenseId === licenseId)

  // Get the battles results of the players who are just around the current player
  const groupData = yield select(firebaseSelectors.getGroupData)
  if (position > 0) {
    const activityOtherPlayer = yield Api.get(
      `/activities?playerId=${ranking[position - 1].licenseId}&session=${groupData.session - 3}`,
      {}
    )
    activityOtherPlayer.map(
      (activity) =>
        (activity.type === 'BATTLE_WON' || activity.type === 'BATTLE_LOST') &&
        activity.data &&
        activity.data.winnerId != licenseId &&
        activity.data.loserId != licenseId &&
        otherPlayersActivity.push(activity)
    )
  }
  if (position < ranking.length - 1) {
    const activityOtherPlayer = yield Api.get(
      `/activities?playerId=${ranking[position + 1].licenseId}&session=${groupData.session - 3}`,
      {}
    )
    activityOtherPlayer.map(
      (activity) =>
        (activity.type === 'BATTLE_WON' || activity.type === 'BATTLE_LOST') &&
        activity.data &&
        activity.data.winnerId != licenseId &&
        activity.data.loserId != licenseId &&
        otherPlayersActivity.push(activity)
    )
  }

  return otherPlayersActivity
}

export function* sagas() {
  yield init()
  yield takeEvery(actions.LOAD_ACTIVITY_DATA, loadActivity)
  yield takeEvery(actions.LOAD_ACTIVITY_BATTLES_VISITING_PLAYERS, loadBattlesFromOthersPlayers)
}
